import { useMutation } from 'react-query';

import { microsoftLogin } from '../../lib/api';

export function useMutateMicrosoftLogin() {
  return useMutation(microsoftLogin);
}
